export default __webpack_public_path__ + "static/media/2020-interior-3.0594c70e.jpeg";